import EzModalController from 'layouts/modal/modal-controller';
import { sendTrackingEvent } from 'components/analytics/conversions/tracking';
import {
  CUSTOMER_FEEDBACK_TRIGGERED,
  CUSTOMER_FEEDBACK_POSITIVE,
  CUSTOMER_FEEDBACK_NEGATIVE,
} from 'components/analytics/conversions/constants/actions';

export default class CustomerFeedbackComponentController extends EzModalController {
  declare readonly element:HTMLElement;

  connect() {
    super.connect();

    sendTrackingEvent({
      element: this.element,
      data: {
        action: CUSTOMER_FEEDBACK_TRIGGERED,
        non_interaction: true,
      },
    });
  }

  positiveResponse(event) {
    sendTrackingEvent({
      element: event.currentTarget,
      data: {
        action: CUSTOMER_FEEDBACK_POSITIVE,
      },
    });
  }

  negativeResponse(event) {
    sendTrackingEvent({
      element: event.currentTarget,
      data: {
        action: CUSTOMER_FEEDBACK_NEGATIVE,
      },
    });
  }
}
